import React, { useState, useEffect } from 'react';
import { Dialog } from '@material-ui/core';
import { scroller } from 'react-scroll';
import { useLanguage } from '../../i18n/LanguageContext';

const ServiceSingle = ({
  open,
  onClose,
  title,
  description,
  dImg,
  icon,
  accent,
  stat,
  mainDescription,
  scopeDescription,
  capabilities,
  capabilitiesDescription,
  approach,
  workProcess,
}) => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('overview');
  const color = accent || '#06b6d4';

  useEffect(() => {
    if (open) setActiveTab('overview');
  }, [open]);

  const handleCTA = () => {
    onClose();
    setTimeout(() => {
      scroller.scrollTo('contact', { smooth: true, duration: 500 });
    }, 300);
  };

  const tabs = [
    { key: 'overview',      label: t.modal.tabOverview },
    { key: 'process',       label: t.modal.tabProcess },
    { key: 'capabilities',  label: t.modal.tabCapabilities },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="svc-modal-dialog"
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          background: '#0f172a',
          border: '1px solid #1e293b',
          borderRadius: 12,
          margin: 16,
          maxHeight: 'calc(100vh - 32px)',
          overflow: 'hidden',
        }
      }}
    >
      <div className="svc-modal">

        {/* ── SIDEBAR ── */}
        <div className="svc-modal__sidebar">
          <span className="svc-modal__label">{t.modal.solutionLabel}</span>
          <div
            className="svc-modal__icon"
            style={{ background: `${color}1a`, border: `1px solid ${color}33` }}
          >
            <i className={`fi ${icon}`} style={{ color }} />
          </div>
          <h3 className="svc-modal__title">{title}</h3>
          <p className="svc-modal__fit">{description}</p>
          {stat && (
            <>
              <hr className="svc-modal__divider" />
              <span className="svc-modal__stat-label">{t.modal.typicalResult}</span>
              <div
                className="svc-modal__stat"
                style={{ background: `${color}0d`, border: `1px solid ${color}26` }}
              >
                <span className="svc-modal__stat-value" style={{ color }}>{stat.value}</span>
                <span className="svc-modal__stat-desc">{stat.label}</span>
              </div>
            </>
          )}
          <div className="svc-modal__spacer" />
          <button className="theme-btn svc-modal__cta" onClick={handleCTA}>
            {t.modal.cta}
          </button>
        </div>

        {/* ── RIGHT PANEL ── */}
        <div className="svc-modal__panel">
          <div className="svc-modal__img-header">
            <img src={dImg} alt={title || ''} />
            <div className="svc-modal__visual-copy">
              <span>{t.modal.visualEyebrow}</span>
              <strong>{t.modal.visualTitle}</strong>
              <ul>
                {t.modal.visualItems.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
            <button
              className="svc-modal__close"
              onClick={onClose}
              aria-label="close"
            >
              ✕
            </button>
          </div>

          <div className="svc-modal__tabs">
            {tabs.map(({ key, label }) => (
              <button
                key={key}
                className={`svc-modal__tab${activeTab === key ? ' active' : ''}`}
                style={activeTab === key ? { color, borderBottomColor: color } : {}}
                onClick={() => setActiveTab(key)}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="svc-modal__tab-content">
            {activeTab === 'overview' && (
              <>
                <p>{mainDescription}</p>
                <p>{scopeDescription}</p>
                <h4 className="svc-modal__section-head">{t.modal.approachHeading}</h4>
                <p>{approach}</p>
              </>
            )}

            {activeTab === 'process' && (
              <>
                <h4 className="svc-modal__section-head">{t.modal.workProcessHeading}</h4>
                <ol className="svc-modal__steps">
                  {workProcess?.map((step, i) => <li key={i}>{step}</li>)}
                </ol>
              </>
            )}

            {activeTab === 'capabilities' && (
              <>
                <h4 className="svc-modal__section-head">{t.modal.capabilitiesHeading}</h4>
                <p>{capabilitiesDescription}</p>
                <ul className="svc-modal__checklist">
                  {capabilities?.map((cap, i) => <li key={i}>{cap}</li>)}
                </ul>
              </>
            )}
          </div>
        </div>

      </div>
    </Dialog>
  );
};

export default ServiceSingle;
